

<template>
  <!-- Breadcrumb Start -->
  <section class="breadcrumb_area">
    <img src="../assets/img/shape_12.png" alt="shape" class="shape_12">
    <img src="../assets/img/shape_13.png" alt="shape" class="shape_13">
    <img src="../assets/img/hero_shape_4.png" alt="img" class="fun_shape_4">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="breadcrumb_inn">
            <h1 class="breadcrumb_title">{{ breadcrumb.title }}</h1>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="javascript:;"><i class="fa fa-angle-right"></i></a></li>
              <li class="active">{{ breadcrumb.link }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Breadcrumb End -->
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    breadcrumb: {
      type: Object,
      default: () => ({
        title: 'The Title',
        link: 'The Link Text'
      }),
      description: 'This is the breadcrumb object property'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue